import React from "react";
import { createPortal } from "react-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";

/**
 * 32px access strip (admin viewing as seller or team member). Portaled to
 * document.body so a Polarised / transformed ancestor cannot trap
 * `position: fixed` under the topbar. Exit lives here and in the avatar menu.
 */
function AccessStrip({ storeLabel, onExit, underTrial }) {
  const strip = (
    <header
      className={`riverr-access-strip${
        underTrial ? " riverr-access-strip--under-trial" : ""
      }`}
      role="banner"
      aria-label="Account access mode"
      style={{
        position: "fixed",
        top: underTrial ? 57 : 0,
        left: 0,
        right: 0,
        zIndex: 20000,
      }}
    >
      <div className="riverr-access-strip__left">
        <button
          type="button"
          className="riverr-access-strip__back"
          onClick={onExit}
        >
          <ArrowBackIcon className="riverr-access-strip__back-icon" />
          <span>Back to admin</span>
        </button>
        <span className="riverr-access-strip__accessing">Accessing</span>
        <span className="riverr-access-strip__store">{storeLabel}</span>
      </div>
      <button type="button" className="riverr-access-strip__exit" onClick={onExit}>
        <CloseIcon className="riverr-access-strip__exit-icon" fontSize="small" />
        <span>Exit access</span>
      </button>
    </header>
  );

  if (typeof document === "undefined") return strip;
  return createPortal(strip, document.body);
}

export default AccessStrip;
